/* unplugin-vue-components disabled */import { render } from "./alert-list.vue?vue&type=template&id=6c7a1e34&scoped=true"
import script from "./alert-list.vue?vue&type=script&lang=js"
export * from "./alert-list.vue?vue&type=script&lang=js"

import "./alert-list.vue?vue&type=style&index=0&id=6c7a1e34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7a1e34"]])

export default __exports__